import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TemplateState = {
  editData: Record<
    string,
    {
      text: string;
      html: string;
    }
  >;
  oldCertId: string;
};

const initialState: TemplateState = {
  editData: {},
  oldCertId: "",
};

const templateSlice = createSlice({
  name: "template",
  initialState: initialState,
  reducers: {
    saveEditTemplateData: (state, action: PayloadAction<TemplateState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearEditTemplateData: () => {
      return initialState;
    },
  },
});

export const { saveEditTemplateData, clearEditTemplateData } = templateSlice.actions;

export default templateSlice.reducer;
